import { selectPublicProfile } from 'src/features/common/profile/ducks/public-profile/public-profile.selectors';
import { useAppSelector } from 'src/hooks/app';

export const usePublicProfile = () => useAppSelector(selectPublicProfile);
